import {InlineLabel} from '@mintdata/mint-kit/impl/properties/components/inlineLabel/InlineLabel';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/blockLabel/BlockLabel.less');
const cx = classnames.bind(styles);

export interface ILabelGroupProps
{
    text?:string;
    className?:string;
    labelClassName?:string;
}

export class BlockLabel extends React.Component<ILabelGroupProps>
{
    public render():JSX.Element
    {
        const {text, children, className, labelClassName} = this.props;

        return (
            <div className={cx('base', className)}>
                {text && <InlineLabel text={text} className={labelClassName} />}
                {children}
            </div>
        );
    }
}

